'use strict';

function CompanySettingInvestigationTemplatesService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/investigation-templates/:investigationTemplatesId', {}, {
    'update': {method: 'PUT'}
  });
}

angular.module('dokiv')
  .factory('CompanySettingInvestigationTemplatesService', ['$resource', 'config', CompanySettingInvestigationTemplatesService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingInvestigationTemplatesService.js
// module id = 409
// module chunks = 0